import React, { useContext } from "react";
import { Dialog, Typography } from "@mui/material";

import { ReactComponent as SuccessIcon } from "assets/img/svg/check-circle.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";

import { UserDetails } from "appContext";
import { FIND_SUCCESS_MESSAGES } from "./utils";

const ApproveDialog = ({ confirmDialog, setConfirmDialog }) => {
  const userDetails = useContext(UserDetails);

  const closeDialog = () => {
    setConfirmDialog({ isOpen: false, data: null });
  };

  return (
    <Dialog open={confirmDialog.isOpen} fullWidth size="md">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          <SuccessIcon width={50} height={50} />
          <CrossIcon onClick={closeDialog} />
        </div>

        <Typography
          variant="h6"
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            my: 3,
          }}
        >
          {FIND_SUCCESS_MESSAGES(
            userDetails?.employeeId,
            confirmDialog?.data.approvalStatus,
            confirmDialog?.data?.remark || "",
          )}
        </Typography>
      </div>
    </Dialog>
  );
};

export default ApproveDialog;
